export default __webpack_public_path__ + "static/media/chevron-right.6fdb4b0c.svg";